import { createContext, useContext, useEffect, useState } from "react";
import { fetchPublicAcademicYears } from "../features/academicOperations/services/academicYearsService";
import { AcademicYear } from "../features/academicOperations/types";

interface AcademicYearContextType {
  currentAcademicYear: string | null;
  setCurrentAcademicYear: (year: string | null) => void;
  academicYears: AcademicYear[] | null;
  setAcademicYears: (year: AcademicYear[] | null) => void;
  loaded: boolean;
}

const AcademicYearContext = createContext<AcademicYearContextType | null>(null);

export const AcademicYearContextProvider = ({ children }: { children: React.ReactNode }) => {
  console.log("Entering AcademicYearContextProvider");
  const [academicYears, setAcademicYears] = useState<AcademicYear[]>([]);
  const [currentAcademicYear, setCurrentAcademicYear] = useState<string | null>(null);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {

    const load = async () => {
      const years = await fetchPublicAcademicYears();
      console.log("AcademicYearContextProvider loaded");
      setAcademicYears(years);

      const active = years.find((y) => y.status === "ACTIVE");
      console.log("AcademicYearContextProvider name: " + active.name);
      if (active) setCurrentAcademicYear(active.name);
      setLoaded(true);
    };
    load();
  }, []);

  return (
    <AcademicYearContext.Provider value={{ academicYears, setAcademicYears, currentAcademicYear, setCurrentAcademicYear, loaded }}>
      {children}
    </AcademicYearContext.Provider>
  );
};

export const useAcademicYearContext = () => {
  console.log("useAcademicYearContext");
  const ctx = useContext(AcademicYearContext);
  if (!ctx) throw new Error("useAcademicYearContext must be used inside AcademicYearContextProvider");
  return ctx;
};